export default {
  // FETCH_PASSAGE2_LIST: (state, { passageList }) => {
  //   state.passageList = passageList;
  // },
  SET_ACTIVE_PASSAGE_GRADE: (state, { grade }) => {
    state.active_passage_grade = grade;
  },
  SET_ACTIVE_PASSAGE: (state, { activePassage }) =>
    (state.active_passage = activePassage),

  SET_PASSAGE_LIST: (state, { passageList }) =>
    (state.passageList = passageList),
  SET_FETCH_PASSAGE_LIST: (state, { value }) =>
    (state.fetch_passage_list = value),
  SET_PASSAGE_RESULT: (state, { result }) => (state.passage_result = result),

  SET_CONCAT_PASSAGE_LIST: (state, { passageList }) =>
    (state.passageList = state.passageList.concat(passageList)),

  SET_ACTIVE_PASSAGE_MCQ: (state, { mcq }) => (state.active_mcq = mcq),
  FETCH_PASSAGE: (state, { value }) => (state.fetchingPassage = value),
};
